import { render, staticRenderFns } from "./ItemCatalogue.vue?vue&type=template&id=9100ddf2&scoped=true&lang=pug"
import script from "./ItemCatalogue.vue?vue&type=script&lang=ts"
export * from "./ItemCatalogue.vue?vue&type=script&lang=ts"
import style0 from "./ItemCatalogue.vue?vue&type=style&index=0&id=9100ddf2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9100ddf2",
  null
  
)

export default component.exports